import client from './client';
import { CreateOrderResponse, Order } from '../types';

const mapOrder = (order: any): Order => ({
    ...order,
    storeName: order.store?.name || order.storeName || 'Unknown Store',
    date: new Date(order.createdAt).toLocaleString('ko-KR'),
});

export const createOrder = async (
    orderData: Partial<Order>,
): Promise<CreateOrderResponse> => {
    const response = await client.post('orders', orderData);
    return response.data;
};

export const getMyOrders = async (name?: string, phone?: string, userId?: string): Promise<Order[]> => {
    const response = await client.get('orders/my', {
        params: { name, phone, userId },
    });
    return response.data.map(mapOrder);
};

export const getAllOrders = async (sellerId?: string, since?: Date): Promise<Order[]> => {
    const response = await client.get('orders/admin', {
        params: { sellerId, since: since?.toISOString() }
    });
    return response.data.map(mapOrder);
};

export const getOrder = async (orderId: string): Promise<Order> => {
    const response = await client.get(`orders/${orderId}`);
    return mapOrder(response.data);
};

export const updateOrderStatus = async (orderId: string, status: string, modifierRole?: string): Promise<Order> => {
    const response = await client.patch(`orders/admin/${orderId}/status`, { status, modifierRole });
    return mapOrder(response.data);
};

export const updateOrderStatusBatch = async (ids: string[], status: string, modifierRole?: string, partialUpdates?: { id: string, itemIds: string[] }[]): Promise<any> => {
    const response = await client.patch('orders/admin/status-batch', { ids, status, modifierRole, partialUpdates });
    return response.data;
};

export const updateOrder = async (orderId: string, orderData: Partial<Order>): Promise<Order> => {
    const response = await client.patch(`orders/${orderId}`, orderData);
    return mapOrder(response.data);
};

export const deleteOrder = async (orderId: string) => {
    const response = await client.delete(`orders/${orderId}`);
    return response.data;
};
